import { render, staticRenderFns } from "./DesafiosForm.vue?vue&type=template&id=67288a20&"
import script from "./DesafiosForm.vue?vue&type=script&lang=js&"
export * from "./DesafiosForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./DesafiosForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports